// 基础路由配置
const baseRouter = [
	{
		path: '/401',
		name: '401',
		component: () => import('@/views/error/401.vue')
	},
	{
		path: '/403',
		name: '403',
		component: () => import('@/views/error/403')
	},
	{
		path: '/',
		name: 'main',
		component: () => import('@/views/layout/layout'),
		redirect: 'index',
		children : [
			{
				path: '/index',
				name: 'index',
				component: () => import('@/views/home/home'),
				meta : {
					title : '舞象云-智慧零售服务商-首页'
				}
			},
			{
				path: '/scrm',
				name: 'scrm',
				component: () => import('@/views/crm/scrm'),
				meta : {
					title : '舞象云-智慧零售服务商-泛CRM体系'
				}
			},
			{
				path: '/member',
				name: 'member',
				component: () => import('@/views/member/member'),
				meta : {
					title : '舞象云-智慧零售服务商-会员运营'
				}
			},
			{
				path: '/case',
				name: 'case',
				component: () => import('@/views/case/case'),
				meta : {
					title : '舞象云-智慧零售服务商-客户案例'
				}
			},
			{
				path: '/about',
				name: 'about',
				component: () => import('@/views/about/about'),
				meta : {
					title : '舞象云-智慧零售服务商-关于我们'
				}
			},
			{
				path: '/newsInfo/:id',
				name: 'newsInfo',
				component: () => import('@/views/about/newsInfo'),
				meta : {
					title : '舞象云-智慧零售服务商-动态详情'
				}
			}
		]
	}
]

export  default baseRouter;



// WEBPACK FOOTER //
// ./src/router/modules/base.js